import frontendRoutes from './routes';
import frontendProtectedRoutes from './privateRoutes';

export { frontendRoutes,frontendProtectedRoutes};